import {gettext} from 'ofs/i18n';

var messages = {
  previousMonth: gettext('Previous Month'),
  nextMonth: gettext('Next Month'),
  shortDays: gettext("Su_Mo_Tu_We_Th_Fr_Sa").split("_"),
  mediumDays: gettext("Sun_Mon_Tue_Wed_Thu_Fri_Sat").split("_"),
  fullDays: gettext("Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday").split("_"),
  shortMonths: gettext("Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec").split("_"),
  fullMonths: gettext("January_February_March_April_May_June_July_August_September_October_November_December").split("_")
};

module.exports = messages;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/datetime-strings.js
 **/